import { useState } from 'react';
import { Card } from 'react-bootstrap';
import './AwardCard.css';

export const AwardCard = ({
  images = [],
  title,
  description,
  recipientName,
  organization,
  date,
  place,
  certificateUrl,
  hasCertificate = false,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const showDots = images.length > 1;
  const showCertificate = hasCertificate && Boolean(certificateUrl);

  return (
    <Card className="award-card">
      <div className="award-card__image-wrap">
        <Card.Img
          src={images[activeIndex]}
          alt={title}
          className="award-card__image"
        />
      </div>

      {showDots ? (
        <div className="award-card__dots">
          {images.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`award-card__dot ${i === activeIndex ? 'award-card__dot--active' : ''}`}
              onClick={() => setActiveIndex(i)}
              aria-label={`Image ${i + 1}`}
            />
          ))}
        </div>
      ) : null}

      <Card.Body className="award-card__body">
        <Card.Title className="award-card__title">{title}</Card.Title>

        {description ? (
          <Card.Text className="award-card__desc">{description}</Card.Text>
        ) : null}

        {recipientName ? (
          <p className="award-card__recipient">{recipientName}</p>
        ) : null}

        {organization ? (
          <p className="award-card__org">{organization}</p>
        ) : null}

        {date ? (
          <p className="award-card__meta">
            {date}
          </p>
        ) : null}

        {place ? (
          <p className="award-card__meta">
            {place}
          </p>
        ) : null}

        {showCertificate ? (
          <a
            href={certificateUrl}
            className="award-card__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg className="award-card__link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
            </svg>
            View Certificate
          </a>
        ) : null}
      </Card.Body>
    </Card>
  );
};
